export default "__VITE_ASSET__clJR85tX__"